// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.ordertypes', {
        url: '/ordertypes?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/ordertypes/ordertypes.tpl.html',
            controller: 'OrderTypesController as vm'
        }},
        resolve: {
            ordertypes: ordertypesResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function ordertypesResolver(OrderTypesApiService, $stateParams) {
    return OrderTypesApiService.getOrderTypes({ page: 0, searchTerm:$stateParams.searchTerm, pageSize:null});
}
// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}
// @ngInject
function OrderTypesController($rootScope, $state, $scope, ordertypes, OrderTypesApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.ordertypes = ordertypes;
    vm.selectedOrderTypeId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.orderTypeId; }, function(newValue, oldValue) {
            vm.selectedOrderTypeId = parseInt($state.params.orderTypeId,10);
        });
        $rootScope.$on('OrderType.Inserted', function(event, response) {
        });
        $rootScope.$on('OrderType.Updated', function(event, response) {
        });
        $rootScope.$on('OrderType.Deleted', function(event, response) {
        });
        $rootScope.$on('OrderType.Changed', function(event, response) {
            loadOrderTypes();
        });
    }

    function loadOrderTypes() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        OrderTypesApiService.getOrderTypes(request).then(function(response) {
            vm.ordertypes = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadOrderTypes();
    }

}

angular
    .module('base.ordertypes', ['ordertypes.api','ordertypes.ordertype'])
    .config(stateConfig)
    .controller('OrderTypesController', OrderTypesController);
